module.exports = __webpack_public_path__ + "static/media/login-bg.67308cb3.png";